import { render, staticRenderFns } from "./cadastrosHome.vue?vue&type=template&id=b35d683a&"
import script from "./cadastrosHome.vue?vue&type=script&lang=js&"
export * from "./cadastrosHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports